import { environment } from '@environment';

export const bugsnagConfig = {
  apiKey: environment.bugsnagId,
  appVersion: environment.version,
  autoTrackSessions: false,
  releaseStage: environment.platform,
  isDeployed: environment.isDeployed,
  groupingRules: [],
};
